import '../typedefs'
import http from '@/http'

const PATH = '/staff/roles'

export default {
    /**
     * @param {ListQuery} params
     * @returns {Promise<void>}
     */
    async listRoles (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ListQuery} params
     * @returns {Promise<void>}
     */
    async listRoleCategories (params) {
        try {
            const response = await http.get(`${PATH}/categories`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {ListQuery} params
     * @returns {Promise<void>}
     */
    async listRoleGroups (params) {
        try {
            const response = await http.get(`${PATH}/groups`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
